const calcSearchResultWidth = (isMyChaynsApp: boolean, width: number): string => {
    if (!isMyChaynsApp && width >= 1000) return '50%';

    if (width < 600) return '100%';
    return '50%';
};

export default calcSearchResultWidth;
